import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from "@angular/common/http";

import { MessageService } from "./message/message.service";
import { SharedService } from "./services/shared.service";
import { WebserviceService } from "./services/webservice.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from './services/common.service';
import { RouterModule } from '@angular/router';

// ngx-bootstrap
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { PusherService } from './services/pusher.service';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FilterPipe } from './pipes/filter.pipe';
import { PaginationComponent } from './components/pagination/pagination.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ScriptLoaderService } from './services/script-loader.service';
import { ChangePasswordComponent } from '../pages/change-password/change-password.component';
import { CookieService } from 'ngx-cookie-service';
import { FormatNumberPipe } from './pipes/format-number.pipe';
import { AppAutoSortAlphabetDirective } from './directive/auto-sort-alphabet.directive';
import { AppAutoSortNumericDirective } from './directive/auto-sort-numeric.directive';
import { TableSearchDirective } from './directive/table-search.directive';


@NgModule({
  declarations: [
    SafeHtmlPipe,
    LoaderComponent,
    FilterPipe,
    PaginationComponent,
    BreadcrumbComponent,
    ChangePasswordComponent,
    FormatNumberPipe,
    AppAutoSortAlphabetDirective,
    AppAutoSortNumericDirective,
    TableSearchDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
      maxOpened: 1,
      autoDismiss: true,
      enableHtml: true
    }),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule,
    ModalModule,
    TabsModule,
    CollapseModule,
    TooltipModule,
    TypeaheadModule,
    BsDropdownModule,
    AccordionModule,
    BsDatepickerModule,
    SafeHtmlPipe,
    LoaderComponent,
    FilterPipe,
    PaginationComponent,
    BreadcrumbComponent,
    ChangePasswordComponent,
    FormatNumberPipe,
    AppAutoSortNumericDirective,
    AppAutoSortAlphabetDirective,
    TableSearchDirective
  ],
  providers: [MessageService, SharedService, WebserviceService, CommonService, ScriptLoaderService, CookieService, {
    provide: ToastrService
  }],
})
export class SharedModule { }
